import * as React from 'react';

import { Container } from 'components/container/Container';
import s from './ArticleHero.scss';

interface IArticleHeroProps {
  children: React.ReactNode;
  heading: string;
  date?: string;
}

function splitIntoBreaks(str: string): React.ReactNode {
  if (!str) {
    return null;
  }

  return str.split('\n').map((part: string, i: number) => {
    return (
      <span key={i}>
        {part}
        <br />
      </span>
    );
  });
}

export const ArticleHero = ({ children, heading, date }: IArticleHeroProps) => {
  
  return (
    <div className={s('articleHero', { empty: !children })}>
      <Container>
        <div className={s.articleHero__inner}>
          <h1 className={s.articleHero__heading}>{splitIntoBreaks(heading)}</h1>
          {date && (
            <div className={s.articleHero__meta}>
              {date && <span className={s.articleHero__date}>{date}</span>}
              <span className={s.articleHero__separator} />
            </div>
          )}
          {children && (<div className={s.articleHero__image}>{children}</div>)}
        </div>
      </Container>
    </div>
  );
};
